<template>
    <div>
        <div class="mt-5 text-center">
            <!-- กำลัง Login Line -->
        </div>
        <modal-master :controller="modalController" :theme="registerUserType"></modal-master>
    </div>
</template>
<script>
//import Vue from 'vue';
import Account from "@/helper/AccountHelper.js";
import LineFunction from "@/helper/facede/LineFunction";
import Locale from '@/helper/locale/locale.js';
//service
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
import BzbsAuth from "@/core/Account/service/BzbsAuth";
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
//mixin
import PDPAMixin from '@/mixin/PDPAMixin.js'
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
import { TermsModalController } from "@/components/Modal/Controller/TermsModalController.js";
import { MarketingRegisterModalController } from "@/components/Modal/Controller/MarketingRegisterModalController.js";
import { AgeConsentModalController } from "@/components/Modal/Controller/AgeConsentModalController.js";

export default {
    name: "LoginLine",
    mixins: [ PDPAMixin, ErrorApiMixin ],
    components: {
        ModalMaster
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            liffId: null,
            user: null,
            targetPage: null,

            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),
            confirmModal: new ConfirmModalController(),
            termsModal: new TermsModalController(),
            marketingRegisterModal: new MarketingRegisterModalController(),
            ageConsentModal: new AgeConsentModalController(),

            errorHandler: null,
        };
    },
    computed: {
        registerState: function () {
            return this.$store.state.state;
        },
        registerUserType: function () {
            return this.$store.state.userType;
        }
    },
    created: function() {
        this.targetPage = this.$route.query.target_page;
        Account.setCacheCustomText('target_page', this.targetPage);
        var liffState = this.getParameterByName("liff.state");
        if (liffState && liffState != '') {
            this.targetPage = this.getParameterByNameFormStr(liffState , "target_page");
            if (this.targetPage && this.targetPage != '') {
                Account.setCacheCustomText('target_page', this.targetPage);
            }

        }
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setConfirmModal(this.confirmModal);
        this.modalController.setTermsModal(this.termsModal);
        this.modalController.setMarketingRegisterModal(this.marketingRegisterModal);
        this.modalController.setAgeConsentModal(this.ageConsentModal);

        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);
        this.errorHandler.setTitle(this.lbl.register.register_alert_headline);

        this.initLiff();
    },
    methods: {
        initLiff: function() {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();
            // this.liffId = '2006048102-yQ78jMGX'; //local

            lineFunction.init(this.liffId).then(() => {
                var currentUrl = window.location.href;
                console.log('curr',currentUrl)
                console.log('function',lineFunction)
                if (lineFunction.isLogin()) {

                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    var idToken = null;
                    lineFunction.getIdToken()
                        .then(result => {
                            idToken = result;
                            Account.setCacheCustom('LineIdToken', idToken);
                                if (idToken != null) {
                                    console.log(idToken);
                                    this.loginBzbs(idToken);
                                } else {
                                    console.log('line token err: cannot get line token');
                                }
                        }).catch(err => {
                            console.log('line token err:', err);
                        });
                } else {

                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                alert(err);
                console.log(err);
            });
        },
        loginBzbs: async function(idToken) {
            this.user = await this.apiLoginLine(idToken);
            console.log(this.user);

            if (this.user) {
                await this.getUserPDPA(this.user.token);
                await Account.apiGetProfile();
                await this.checkPdpa(this.targetPage);
                await this.redirectLogin();
            }
        },
        apiLoginLine: async function(idToken) {
            return new Promise((resolve, reject) => {
                this.loadingModal.show();
                BzbsAuth.apiLoginLine(idToken).then((res) => {
                    this.loadingModal.hide();
                    Account.setLogin(res.data);
                    resolve(res.data);
                }, (err) => {
                    console.log(err)
                    var targetPage = Account.getCacheCustom("target_page");
                    var page = '';
                    var param = '';

                    if (targetPage) {
                            var objPage = targetPage.split("/");

                            if (objPage.length > 1) {
                                page = objPage[0];
                                param = objPage[1];
                            } else {
                                page = targetPage;
                            }
                        }

                    if (err.response && err.response.data && err.response.data.error.code == 409) {
                        if (err.response.data.error.id == 100000) {
                            this.errorCaseFruad();
                        } else {
                            if(page == 'getfriend'){
                                window.location.replace(`/register/line?getfriendRefcode=${param}`)
                            }else{
                                window.location.replace('/register/line');
                            }
                        }
                    } else  if (err.response && err.response.data && err.response.data.error.code == 403) {
                        this.errorCase403();
                    } else {
                        switch (page) {
                            case 'getfriend':
                                Account.setCacheCustomText('target_page', 'getfriend');
                                window.location.replace('/getfriend/' + param);
                                break;
                            default:
                                window.location.replace('/register/line');
                                break;
                        }
                    }
                    this.loadingModal.hide();
                    reject(err);
                });
            });
        },
        redirectNotLogin: function() {
            // var targetPage = this.$route.query.target_page;
            // Account.setCacheCustom('target_page', targetPage);
            window.location.replace('/term');
            // switch (targetPage) {
            //     case 'register':
            //         Account.setCacheCustom('target_page', 'register');
            //         this.$router.push('/term');
            //         break;
            //     case 'home':
            //         Account.setCacheCustom('target_page', 'home');
            //         this.$router.push('/term');
            //         break;
            //     default:
            //         Account.setCacheCustom('target_page', 'register');
            //         this.$router.push('/term');
            // }
        },
        redirectLogin: function() {
            var targetPage = Account.getCacheCustom("target_page");
            if (targetPage != null
                && targetPage != undefined
                && targetPage != 'undefined'
                && targetPage) {

                if (targetPage == 'reward') {
                    window.location.replace('/home');
                } else if(targetPage.indexOf('product/category') > -1 || targetPage.indexOf('privilege/category') > -1 || targetPage.indexOf('marketplace/category') > -1){
                    let page = targetPage.split('/');
                    if(page.length > 1){
                        Account.setCacheCustom('category', {'id': page[2]});
                    }
                    window.location.replace(`/${page[0]}`);
                }else{
                    window.location.replace(`/${targetPage}`);
                }

                Account.setCacheCustomText('target_page', targetPage);

            } else {
                Account.setCacheCustomText('target_page', 'profile');
                window.location.replace('/home');
            }
        },
        getParameterByName: function(name) {
            name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },
        getParameterByNameFormStr(str,name) {
            name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(str);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },
        getUserPDPA: function (token) {
            const pdpa = Account.getCacheCustom('marketingConsent');
            console.log(pdpa);

            BzbsPDPA.apiGetUserPDPA(token).then((res) => {
                console.log(res);
                const dataPDPA = res.data;
                const consentModel = new PDPAModel();
                const consent = {
                    termandcondition: dataPDPA.TermAndCondition,
                    dataprivacy: dataPDPA.DataPrivacy,
                    consentAge: 20,
                    email: pdpa.email,
                    sms: pdpa.sms,
                    // notification: pdpa.notification,
                    line: pdpa.line,
                    marketingOption: pdpa.marketingOption
                }
                consentModel.setPDPAModel(consent);
                const params = consentModel.getParams();
                console.log(params);
                this.updatePdpaConsent(token, params);
            })
        },
        updatePdpaConsent: function(token, params) {
            BzbsPDPA.apiUpdateUserPDPA(token, params).then( () => {
                Account.removeCacheCustom('marketingConsent');
            }).catch( err => {
                this.errorResponse(err, this.errorHandler);
            });
        },
        errorCase403: function() {
            this.alertModal
                .clearText()
                .setTitle(this.lbl.register.err_403.title)
                .setMsg(this.lbl.register.err_403.msg)
                .setBtnOk(this.lbl.default.close)
                .show();

            this.alertModal.onClickOk(() => {
                let line = new LineFunction();
                let liffId = line.getLiffId();
                line.init(liffId).then(() => {
                    line.closeWindow();
                });
            });
        },
        errorCaseFruad: function() {
            this.alertModal
                .clearText()
                .setTitle(this.lbl.register.err_fruad.title)
                .setMsg(this.lbl.register.err_fruad.msg)
                .setBtnOk(this.lbl.default.close)
                .show();

            this.alertModal.onClickOk(() => {
                let line = new LineFunction();
                let liffId = line.getLiffId();
                line.init(liffId).then(() => {
                    line.closeWindow();
                });
            });
        }
    },
}
</script>
